export default __webpack_public_path__ + "static/akitabox_w.fb8dcb21a309e32ea0bdb2512292a9f1.svg";